/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrameworkMapping
 */
export interface FrameworkMapping {
    /**
     * 
     * @type {string}
     * @memberof FrameworkMapping
     */
    framework?: string;
    /**
     * 
     * @type {string}
     * @memberof FrameworkMapping
     */
    frameworkId?: string;
    /**
     * 
     * @type {string}
     * @memberof FrameworkMapping
     */
    controlId?: string;
}

/**
 * Check if a given object implements the FrameworkMapping interface.
 */
export function instanceOfFrameworkMapping(value: object): value is FrameworkMapping {
    return true;
}

export function FrameworkMappingFromJSON(json: any): FrameworkMapping {
    return FrameworkMappingFromJSONTyped(json, false);
}

export function FrameworkMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrameworkMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'framework': json['framework'] == null ? undefined : json['framework'],
        'frameworkId': json['frameworkId'] == null ? undefined : json['frameworkId'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
    };
}

export function FrameworkMappingToJSON(json: any): FrameworkMapping {
    return FrameworkMappingToJSONTyped(json, false);
}

export function FrameworkMappingToJSONTyped(value?: FrameworkMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'framework': value['framework'],
        'frameworkId': value['frameworkId'],
        'controlId': value['controlId'],
    };
}

